import { render } from "./Homa.vue?vue&type=template&id=a7b65d92"
import script from "./Homa.vue?vue&type=script&lang=js"
export * from "./Homa.vue?vue&type=script&lang=js"

import exportComponent from "/data/home/geraldo/git/Intmain/lowcarb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__